export default class NewBusinessApplicationDocument {
	public applicationId: number | null = null;
	public documentName: string | null = null;
	public documentUrl: string | null = null;
	public message: string | null = null;
};